import React from 'react'
import PropTypes from 'prop-types'

import { ReactQueryClientProvider } from '@termly-web/common'

import ResourceBlockerIntlProvider from 'components/ResourceBlockerIntlProvider'

import LocalizedAppContent from './LocalizedAppContent'


export default function App({ children, consentConfig, countryCode, isFirstPaintGated, rootElem, website }) {
  return (
    <ReactQueryClientProvider>
      <ResourceBlockerIntlProvider
        isFirstPaintGated={ isFirstPaintGated }
        rootElem={ rootElem }
        supportedLocales={ consentConfig.language_setting }
      >
        <LocalizedAppContent
          consentConfig={ consentConfig }
          countryCode={ countryCode }
          website={ website }
        >
          { children }
        </LocalizedAppContent>
      </ResourceBlockerIntlProvider>
    </ReactQueryClientProvider>
  )
}

App.propTypes = {
  children: PropTypes.node,
  consentConfig: LocalizedAppContent.propTypes.consentConfig,
  countryCode: LocalizedAppContent.propTypes.countryCode,
  isFirstPaintGated: ResourceBlockerIntlProvider.propTypes.isFirstPaintGated,
  rootElem: ResourceBlockerIntlProvider.propTypes.rootElem,
  website: LocalizedAppContent.propTypes.website,
}
